module.exports = __webpack_public_path__ + "static/media/L (2).bfd0c875.jpg";